import React from "react";
import "../styles/NotFound.css";

const NotFound = () => {
  return (
    <div className="not-found center-col">
      <h2>404 - Not Found</h2>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;
